import type {IFormaPagamento} from "@models/formaPagamento/IFormaPagamento.ts";
import React from "react";
import {DefaultConsumerPesquisaAutoProps, DefaultPesquisaAuto} from "@shared/specialComponents/DefaultPesquisaAuto.tsx";
import {IGetFormaPagtoFilter} from "@components/formaPagamento/models/GetFormaPagtoFilter.ts";
import {__formapagto_endpoints} from "@components/formaPagamento/endpoints/__formapagto_endpoints.ts";

interface FormaPagamentoPesquisaProps extends DefaultConsumerPesquisaAutoProps<IFormaPagamento, IGetFormaPagtoFilter> {
}

export function FormaPagamentoPesquisa(props: FormaPagamentoPesquisaProps) {
    const handleItemSelected = (item?: IFormaPagamento) => {
        if (props.onItemSelected) {
            props.onItemSelected(item);
        }
    };

    const formatar = (v: IFormaPagamento) => `${v.id} ${v.nome} ${(v.isAntecipacao ? '(Antecipação)' : '')}`;

    return (
        <DefaultPesquisaAuto {...props}
                             endpoint={__formapagto_endpoints.v2["get-formas-pagto"]}
                             onItemSelected={handleItemSelected}
                             searchField={'nome'}
                             display={{name: 'Forma de pagamento'}}
                             itemToString={formatar}/>
    );
};